<template>
  <div class="select-date-wrapper">
    <CommonInput
      type="text"
      theme="white"
      :max-length="maxlength"
      :placeholder="placeholder"
      readonly
      v-model="formatCurrentValue"
      :onFocus="showPopup"
    />
    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '40%', overflow: 'hidden' }"
      :safe-area-inset-bottom="true"
    >
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :title="placeholder"
        :confirm-button-text="$t('common.confirm')"
        :cancel-button-text="$t('common.cancel')"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="closePopup"
        @confirm="confirm"
        :columns-order="['day', 'month', 'year']"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { DatetimePicker } from 'vant'
import moment from 'moment'
import CommonInput from '@/components/CommonInput.vue'

Vue.use(DatetimePicker)

export default {
  name: 'SelectDate',
  components: {
    CommonInput
  },
  data() {
    return {
      show: false,
      currentValue: this.value,
      minDate: new Date(1900, 0, 1),
      maxDate: this.defaultMaxDate ? new Date(this.defaultMaxDate) : new Date(2050, 11, 31),
      currentDate: this.defaultDate ? new Date(this.defaultDate) : new Date(),
      formatCurrentValue: this.value ? moment(this.value).format('DD-MM-YYYY') : ''
    }
  },
  watch: {
    currentValue(val) {
      if (val) {
        this.formatCurrentValue = moment(val).format('DD-MM-YYYY')
      } else {
        this.formatCurrentValue = ''
      }
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: String,
    maxlength: Number,
    placeholder: String,
    defaultDate: String,
    defaultMaxDate: String
  },
  methods: {
    showPopup() {
      this.show = true
    },
    closePopup() {
      this.show = false
    },
    confirm(value) {
      this.show = false
      const formatDate = moment(value).format('YYYY-MM-DD')
      this.currentValue = formatDate
      this.$emit('change', formatDate)
    }
  }
}
</script>

<style scoped>
.select-date-wrapper {
  width: 100%;
}
</style>

<style>
.select-date-wrapper .van-picker__cancel,
.select-date-wrapper .van-picker__confirm {
  font-weight: 500;
}

.select-date-wrapper .van-cell {
  cursor: unset;
  background-color: unset;
  width: 100%;
  height: 0.36rem;
  padding: 0;
  text-align: center;
  font-size: 0.14rem;
  margin: 0;
}

.select-date-wrapper .van-field__body {
  height: 100%;
}

.select-date-wrapper .van-field__control {
  text-align: center;
  margin: auto 0;
  color: #2c3e50;
}

.select-date-wrapper .van-field__control::-webkit-input-placeholder {
  color: #7c7c7c;
  font-size: 0.14rem;
}

.select-date-wrapper .van-cell::after {
  content: none;
}

.select-date-wrapper .van-cell--clickable:active {
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/components/SelectDate.vue